const TOLERANCIA = 0.0001;

function cislo(hodnota) {
  const vysledok = Number(hodnota);

  return Number.isFinite(vysledok)
    ? vysledok
    : 0;
}

function zaokruhliNaDesatinu(hodnota) {
  return Math.round(
    (cislo(hodnota) + Number.EPSILON) *
      10
  ) / 10;
}

function zaokruhliVahuNahor(hodnota) {
  return Math.ceil(
    (cislo(hodnota) - Number.EPSILON) *
      10
  ) / 10;
}

function formatujCislo(hodnota) {
  return cislo(hodnota).toLocaleString(
    "sk-SK",
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    }
  );
}

function vytvorTypInvesticie(
  maMesacnuChybu,
  maJednorazovuChybu
) {
  if (
    maMesacnuChybu &&
    maJednorazovuChybu
  ) {
    return "mesačnú aj jednorazovú";
  }

  return maMesacnuChybu
    ? "mesačnú"
    : "jednorazovú";
}

function vytvorTypInvesticieNominativ(
  maMesacnuChybu,
  maJednorazovuChybu
) {
  if (
    maMesacnuChybu &&
    maJednorazovuChybu
  ) {
    return "mesačná aj jednorazová";
  }

  return maMesacnuChybu
    ? "mesačná"
    : "jednorazová";
}

export function vyhodnotMinimalneInvesticieVah({
  polozky = [],
  vahy = {},
  mesacnyVklad = 0,
  jednorazovyVklad = 0,
}) {
  if (polozky.length < 2) {
    return {
      platne: true,
      hlavnaSprava: "",
      spravy: [],
    };
  }

  const mesacne = Math.max(
    0,
    cislo(mesacnyVklad)
  );

  const jednorazovo = Math.max(
    0,
    cislo(jednorazovyVklad)
  );

  const vyhodnotenePolozky =
    polozky.map((polozka) => {
      const minima =
        polozka.minimalnaInvesticia || {};

      const pocetFondov = Math.max(
        1,
        Math.trunc(
          cislo(polozka.pocetFondov)
        )
      );

      const minimumMesacne = Math.max(
        0,
        cislo(minima.mesacne)
      ) * (
        minima.mesacneZaFond === true
          ? pocetFondov
          : 1
      );

      const minimumJednorazovo =
        Math.max(
          0,
          cislo(minima.jednorazovo)
        );

      const vaha = Math.max(
        0,
        cislo(vahy[polozka.kluc])
      );

      const prideleneMesacne =
        zaokruhliNaDesatinu(
          mesacne * vaha / 100
        );

      const prideleneJednorazovo =
        zaokruhliNaDesatinu(
          jednorazovo * vaha / 100
        );

      const maMesacnuChybu =
        mesacne > 0 &&
        minimumMesacne > 0 &&
        prideleneMesacne +
          TOLERANCIA <
          minimumMesacne;

      const maJednorazovuChybu =
        jednorazovo > 0 &&
        minimumJednorazovo > 0 &&
        prideleneJednorazovo +
          TOLERANCIA <
          minimumJednorazovo;

      const potrebnaMesacnaVaha =
        mesacne > 0 &&
        minimumMesacne > 0
          ? minimumMesacne /
            mesacne * 100
          : 0;

      const potrebnaJednorazovaVaha =
        jednorazovo > 0 &&
        minimumJednorazovo > 0
          ? minimumJednorazovo /
            jednorazovo * 100
          : 0;

      return {
        ...polozka,
        minimumMesacne,
        minimumJednorazovo,
        prideleneMesacne,
        prideleneJednorazovo,
        maMesacnuChybu,
        maJednorazovuChybu,
        potrebnaVaha: Math.max(
          potrebnaMesacnaVaha,
          potrebnaJednorazovaVaha
        ),
      };
    });

  const chybnePolozky =
    vyhodnotenePolozky.filter(
      (polozka) =>
        polozka.maMesacnuChybu ||
        polozka.maJednorazovuChybu
    );

  if (chybnePolozky.length === 0) {
    return {
      platne: true,
      hlavnaSprava: "",
      spravy: [],
    };
  }

  const sucetPotrebnychVah =
    vyhodnotenePolozky.reduce(
      (spolu, polozka) =>
        spolu + polozka.potrebnaVaha,
      0
    );

  const mozneUpravitVahami =
    sucetPotrebnychVah <=
      100 + TOLERANCIA;

  const maMesacnuChybu =
    chybnePolozky.some(
      (polozka) =>
        polozka.maMesacnuChybu
    );

  const maJednorazovuChybu =
    chybnePolozky.some(
      (polozka) =>
        polozka.maJednorazovuChybu
    );

  const typInvesticie =
    vytvorTypInvesticie(
      maMesacnuChybu,
      maJednorazovuChybu
    );

  const typInvesticieNominativ =
    vytvorTypInvesticieNominativ(
      maMesacnuChybu,
      maJednorazovuChybu
    );

  const spravy = chybnePolozky.map(
    (polozka) => {
      const detaily = [];

      if (polozka.maMesacnuChybu) {
        detaily.push(
          `mesačne ${formatujCislo(
            polozka.prideleneMesacne
          )} € z minima ${formatujCislo(
            polozka.minimumMesacne
          )} €`
        );
      }

      if (
        polozka.maJednorazovuChybu
      ) {
        detaily.push(
          `jednorazovo ${formatujCislo(
            polozka
              .prideleneJednorazovo
          )} € z minima ${formatujCislo(
            polozka.minimumJednorazovo
          )} €`
        );
      }

      const zaklad = `${
        polozka.nazov
      }: ${detaily.join(", ")}.`;

      if (!mozneUpravitVahami) {
        return zaklad;
      }

      return `${zaklad} Upravte váhu minimálne na ${formatujCislo(
        zaokruhliVahuNahor(
          polozka.potrebnaVaha
        )
      )} % alebo zvýšte ${vytvorTypInvesticie(
        polozka.maMesacnuChybu,
        polozka.maJednorazovuChybu
      )} investíciu vo vstupných parametroch.`;
    }
  );

  return {
    platne: false,

    hlavnaSprava:
      mozneUpravitVahami
        ? "Minimálna výška investície nie je splnená. Upravte váhy alebo zvýšte investíciu vo vstupných parametroch."
        : `Zadaná ${typInvesticieNominativ} investícia nestačí pre zvolenú kombináciu produktov. Zvýšte ${typInvesticie} investíciu alebo znížte počet vybraných produktov.`,

    spravy,
  };
}